import React, { useEffect, useState } from 'react';
import styles from './MileageSaarathi.module.css';
import CustomSelectButton from './CustomSelectButton';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import ChartLoader from './Loader_MS_bus';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

function FleetLevelSummaryTable(props) {
    const { filterdata } = props
    const [vehicleData, setVehicleData] = useState([]);
    const [gtFiveHundred, setGtFiveHundred] = useState(false);
    const { isLoading, sendReq: fetchData } = useHttp();

    const [vinNo, setVinNumber] = useState([]);
    const [regNo, setRegNumber] = useState([]);
    const [selectedField, setSelectedField] = useState("VIN_NUM");

    // NEW: Toggle state
    const [viewMode, setViewMode] = useState("summary"); // "summary" | "detailed"

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 4;

    const totalPages = Math.ceil(vehicleData.length / itemsPerPage);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const [sortKey, setSortKey] = useState({
        key: "Actual_Energy_Efficiency",
        asc: true
    });

    useEffect(() => {
        setVehicleData([]);

        // let endpoint = `mileage_sarathi_ace/${gtFiveHundred
        //     ? "fleet_summary_Vehicle_level_summary_greaterthan_500k_fleet"
        //     : "fleet_summary_Vehicle_level_summary_vin_fleet"
        // }`;
        let endpoint = "";

        if (viewMode === "summary") {
            // COMMUNITY API
            endpoint = `mileage_sarathi_ace/${gtFiveHundred
                ? "fleet_summary_Vehicle_level_summary_greaterthan_500k"
                : "fleet_summary_Vehicle_level_summary_vin"
                }`;
        } else {
            // FLEET API
            endpoint = `mileage_sarathi_ace/${gtFiveHundred
                ? "fleet_summary_Vehicle_level_summary_greaterthan_500k_fleet"
                : "fleet_summary_Vehicle_level_summary_vin_fleet"
                }`;
        }


        fetchData(
            {
                url: API_URL_MAIN + endpoint,
                body: {
                    filterdata: {
                        ...filterdata,
                        VIN_NUM: selectedField === "VIN_NUM" ? vinNo : [],
                        REG_NUM: selectedField === "REG_NUM" ? regNo : []
                    }
                }
            },
            (data) => {
                let resData = data.results;

                const mappedData = resData.map(item => ({
                    ...item,
                    Distance: item.Distance?.value ?? null,
                    Energy_Consumption: item.Energy_Consumption?.value ?? null,
                    targetEnergyEff: item.Target_Energy_Efficiency?.value ?? null,
                    Actual_Energy_Efficiency: item.Actual_Energy_Efficiency?.value ?? null,
                    Potential_Cost_Saving: item.Potential_Cost_Saving ?? null,
                }));

                setVehicleData(mappedData);
                setCurrentPage(1);
            }
        );
    }, [filterdata, gtFiveHundred, vinNo, regNo, selectedField, viewMode]);

    const currentItems = vehicleData
        .sort((a, b) =>
            sortKey.asc
                ? a[sortKey.key] - b[sortKey.key]
                : b[sortKey.key] - a[sortKey.key]
        )
        .slice(indexOfFirstItem, indexOfLastItem);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const updateFilter = (arr) => {
        setVinNumber(arr);
    };

    const updateFilterForREGNo = (arr) => {
        setRegNumber(arr);
    };

    const sortFunction = (key) => {
        setSortKey(prev => ({ key, asc: !prev.asc }));
    };

    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheettml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const excelFileName = "Vehicle Level Summary";

    const exportToExcel = async (e) => {
        e.preventDefault();
        const flatData = vehicleData.map((item, index) => ({
            'Sr. no': index + 1,
            'Vin': item.key.vehicleId,
            'Registration Number': item.key.vehicle_registration_number,
            'Distance Traveled': item.Distance + ' Kms',
            'Energy Consumption': item.Energy_Consumption + ' Wh',
            'Target Energy Efficiency': item.targetEnergyEff?.toFixed(2) + ' Wh/Km',
            'Actual Energy Efficiency': item.Actual_Energy_Efficiency?.toFixed(2) + ' Wh/Km',
            'Potential Cost Saving': item.Potential_Cost_Saving != null
                ? (Number(item?.targetEnergyEff || 0) - Number(item?.Actual_Energy_Efficiency))?.toFixed(2) < 0
                    ? "\u20B9 " + item.Potential_Cost_Saving?.toFixed(2)
                    : "\u20B9 " + 0
                : ""
        }));

        const ws = XLSX.utils.json_to_sheet(flatData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, excelFileName + fileExtension);
    };

    return (
        <div className='mb-3'>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <h6 className={`m-0 fw-bold ${styles.date_range_selection}`}>Vehicle Level Summary</h6>
                </div>

                <div className="d-flex align-items-center">
                    {/* Toggle Buttons moved here */}
                    <div className="btn-group me-3" role="group">
                        <button
                            type="button"
                            className={`btn btn-sm ${viewMode === "summary" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setViewMode("summary")}
                        >
                            Community
                        </button>
                        <button
                            type="button"
                            className={`btn btn-sm ${viewMode === "detailed" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setViewMode("detailed")}
                        >
                            Fleet
                        </button>
                    </div>

                    {/* Download button */}
                    <a href="#" className={`text-decoration-none ${styles.download_button} ${isLoading ? 'text-muted' : ""}`}
                        style={{ pointerEvents: isLoading ? "none" : "" }}
                        onClick={exportToExcel}>
                        <i className="fas fa-download me-1"></i>Download Report
                    </a>
                </div>
            </div>

            {/* Filters */}
            <div className="row mb-3">
                <div className="col-md-2">
                    <select className={`form-select ${styles.filter_dropdown}`}
                        value={selectedField}
                        onChange={(e) => setSelectedField(e.target.value)}>
                        <option value="VIN_NUM">VIN No.</option>
                        <option value="REG_NUM">Reg. No.</option>
                    </select>
                </div>
                <div className="col-md-3">
                    {selectedField === "VIN_NUM" ? (
                        <CustomSelectButton
                            apiEnd="fleet_summary_Vehicle_no_filter"
                            filterdata={filterdata}
                            updateFilter={updateFilter}
                        />
                    ) : (
                        <CustomSelectButton
                            apiEnd="fleet_summary_registeration_no_filter"
                            filterdata={filterdata}
                            updateFilter={updateFilterForREGNo}
                        />
                    )}
                </div>
                <div className="col-md-4 d-flex align-items-center">
                    <div className="form-check form-switch me-4 d-flex align-items-center">
                        <label className="form-check-label small text-nowrap" htmlFor="allVehicles">All Vehicles</label>
                    </div>
                    <div className="form-check form-switch d-flex align-items-center">
                        <input
                            className={`form-check-input ${styles.toggle_button}`}
                            type="checkbox"
                            id="runningVehicles"
                            value={gtFiveHundred}
                            onChange={() => setGtFiveHundred(prev => !prev)}
                        />
                        <label className="form-check-label small text-nowrap" htmlFor="runningVehicles">
                            Vehicles running more than 500 Kms per month
                        </label>
                    </div>
                </div>
            </div>

            <div className="small text-muted mb-3 text-start">
                Disclaimer: Potential cost will vary as per the respective city's energy cost in Wh per unit.
            </div>

            {/* Table */}
            <div className={`table-responsive ${styles.table_vehicles_container}`} style={{ minHeight: "230px", position: "relative" }}>
                <table className={`table table-hover text-start m-0 ${styles.table}`} >
                    <thead>
                        <tr className={`${styles.tableHeaderRow}`}>
                            <th className={`${styles.table_HeaderCell}`}>Vehicle Details</th>
                            <th onClick={() => sortFunction("Distance")}>Distance <i className={`fas fa-sort ${styles.sortIcon}`}></i></th>
                            <th onClick={() => sortFunction("Energy_Consumption")}>Energy Consumption <i className={`fas fa-sort ${styles.sortIcon}`}></i></th>
                            <th onClick={() => sortFunction("targetEnergyEff")}>Target Energy Efficiency <i className={`fas fa-sort ${styles.sortIcon}`}></i></th>
                            <th onClick={() => sortFunction("Actual_Energy_Efficiency")}>Actual Energy Efficiency <i className={`fas fa-sort ${styles.sortIcon}`}></i></th>
                            <th onClick={() => sortFunction("Potential_Cost_Saving")}>Potential Cost Saving <i className={`fas fa-sort ${styles.sortIcon}`}></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan={6} style={{ padding: 0 }}>
                                    <ChartLoader />
                                </td>
                            </tr>
                        ) : currentItems?.length ? (
                            currentItems.map((vehicle, index) => {
                                let value = (Number(vehicle?.targetEnergyEff || 0) - Number(vehicle?.Actual_Energy_Efficiency))?.toFixed(2);
                                return (
                                    <tr key={index} className={`${styles.sortIcon}`}>
                                        <td>
                                            <p className="m-0">{vehicle?.key?.vehicleId || "--"}</p>
                                            <p className="m-0">{vehicle?.key?.vehicle_registration_number || "--"}</p>
                                        </td>
                                        <td><p>{vehicle?.Distance != null ? vehicle?.Distance + " Kms" : "--"}</p></td>
                                        <td><p>{vehicle?.Energy_Consumption ? Math.round(vehicle?.Energy_Consumption) + " Wh" : "--"}</p></td>
                                        <td><p>{vehicle?.targetEnergyEff != null ? vehicle?.targetEnergyEff?.toFixed(2) + " Wh/Km" : "--"}</p></td>
                                        <td>
                                            <p className="m-0">{vehicle?.Actual_Energy_Efficiency ? vehicle?.Actual_Energy_Efficiency?.toFixed(2) + " Wh/km" : "--"}</p>
                                            {vehicle?.Actual_Energy_Efficiency ? (
                                                value < 0 ? (
                                                    <p className="m-0  text-danger">({value + ' ▼' || "--"})</p>
                                                ) : (
                                                    <p className="m-0 text-success">({value + ' ▲' || "--"})</p>
                                                )
                                            ) : (
                                                <p className='m-0'>--</p>
                                            )}
                                        </td>
                                        {vehicle.Potential_Cost_Saving != null ? (
                                            <td>{value < 0 ? <p>{'₹ ' + vehicle.Potential_Cost_Saving || "--"}</p> : <p>₹ 0</p>}</td>
                                        ) : (
                                            <td><p>--</p></td>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={6} className='text-center table-cell'> No Data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {currentItems?.length ? (
                <>
                    <div className="small text-muted mt-2">
                        Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, vehicleData.length)} of {vehicleData.length} entries
                    </div>
                    <div className="d-flex justify-content-center mt-3 align-items-center" >
                        <button
                            className={`${currentPage === 1 ? "btn btn-link" : styles.ms_button}`}
                            onClick={handlePrevPage}
                            disabled={currentPage === 1}
                        >
                            <i className={`fas fa-chevron-left ms_button`}></i> Prev
                        </button>

                        {currentPage > 3 && (
                            <>
                                <button
                                    className={`mx-1 ${currentPage === 1 ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(1)}
                                >
                                    1
                                </button>
                                {currentPage !== 4 && <span className="mx-1">...</span>}
                            </>
                        )}

                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(page =>
                                page === currentPage ||
                                page === currentPage - 1 ||
                                page === currentPage + 1
                            )
                            .map(page => (
                                <button
                                    key={page}
                                    className={`mx-1 btn btn-sm ${currentPage === page ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(page)}
                                >
                                    {page}
                                </button>
                            ))}

                        {currentPage < totalPages - 2 && (
                            <>
                                {currentPage !== totalPages - 3 && <span className="mx-1">...</span>}
                                <button
                                    className={`mx-1 btn btn-sm ${currentPage === totalPages ? styles.page_number_icons_prev : styles.page_number_icons_next}`}
                                    onClick={() => handlePageChange(totalPages)}
                                >
                                    {totalPages}
                                </button>
                            </>
                        )}

                        <button
                            className={` ${currentPage === totalPages ? "btn btn-link" : styles.ms_button}`}
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                        >
                            Next <i className="fas fa-chevron-right"></i>
                        </button>
                    </div>
                </>
            ) : null}
        </div>
    );
}

export default FleetLevelSummaryTable;
